export default "__VITE_ASSET__CysAiOPR__"